module.exports = __webpack_public_path__ + "img/graph-down.2af5b196.svg";